var _style, _g, _path, _path2, _path3, _path4, _path5, _path6, _polygon, _polygon2, _path7, _polygon3, _path8, _path9, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTraffixcolored(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 500 500",
    style: {
      enableBackground: "new 0 0 500 500"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:url(#SVGID_1_);}\n\t.st1{fill:url(#SVGID_2_);}\n\t.st2{fill:url(#SVGID_3_);}\n\t.st3{fill:url(#SVGID_4_);}\n\t.st4{fill:url(#SVGID_5_);}\n\t.st5{fill:url(#SVGID_6_);}\n\t.st6{fill:url(#SVGID_7_);}\n\t.st7{fill:url(#SVGID_8_);}\n\t.st8{fill:url(#SVGID_9_);}\n\t.st9{fill:url(#SVGID_10_);}\n\t.st10{fill:url(#SVGID_11_);}\n\t.st11{fill:url(#SVGID_12_);}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Calque_1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Calque_4"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 140.5831,
    y1: 277.762,
    x2: 142.0237,
    y2: 222.1203
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#373A0F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9117,
    style: {
      stopColor: "#71AF37"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M129.6,257.1v27h-16.1v-68.2h30c5.5,0,10,0.6,13.3,1.9c3.3,1.3,6.1,3.6,8.3,7.1c2.2,3.4,3.3,7.2,3.3,11.4 c0,8.2-3.9,14.1-11.8,17.6l12.6,30.2h-17.7l-10.5-27H129.6z M129.6,228v17.4h9.8c3.2,0,5.5-0.2,7-0.7c1.4-0.4,2.7-1.4,3.9-3 c1.1-1.5,1.7-3.3,1.7-5.3c0-1.9-0.6-3.6-1.7-5.1c-1.1-1.5-2.4-2.4-3.7-2.8c-1.3-0.3-3.8-0.5-7.5-0.5H129.6z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 204.6336,
    y1: 282.0577,
    x2: 206.5488,
    y2: 220.3813
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#373A0F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9117,
    style: {
      stopColor: "#71AF37"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M214.1,215.9l21.3,68.2h-17.2l-4.2-14H192l-4.3,14h-14l21.9-68.2H214.1z M195.8,257.5h14.5l-7.2-23.9 L195.8,257.5z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 265.116,
    y1: 278.8734,
    x2: 264.6219,
    y2: 230.3605
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#373A0F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9117,
    style: {
      stopColor: "#71AF37"
    }
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M289.1,229.4h-31.9v15.3h25.2v12.7h-25.2v26.7h-16.6v-68.2h48.5V229.4z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 319.4195,
    y1: 282.866,
    x2: 317.9925,
    y2: 234.3715
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#373A0F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9117,
    style: {
      stopColor: "#71AF37"
    }
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M342.7,229.4h-31.9v15.3H336v12.7h-25.2v26.7h-16.6v-68.2h48.5V229.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 73.1218,
    y1: 250.0023,
    x2: 107.117,
    y2: 250.0023
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#373A0F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9117,
    style: {
      stopColor: "#71AF37"
    }
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M107.1,215.9c0,5.8,0,11.3,0,16.8c-1.6,0.3-3.1,0.5-4.6,0.9c-7.4,2.1-12.4,8.7-12.5,16.5 c0,10.6,0,21.2,0,31.8c0,0.7,0,1.4,0,2.2c-5.6,0-11.2,0-17,0c0-0.6,0-1.2,0-1.8c0-10.6,0-21.1,0-31.7 c0-17.3,11.8-31.4,28.9-34.3C103.6,216.1,105.3,216,107.1,215.9z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: 55.5235,
    y1: 224.477,
    x2: 89.829,
    y2: 224.477
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#373A0F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9117,
    style: {
      stopColor: "#71AF37"
    }
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M89.8,215.9H55.7l-0.2,17.2h17.9c1.2-2.5,3.1-5.8,6-9.1C83.2,219.9,87.1,217.3,89.8,215.9z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_",
    gradientUnits: "userSpaceOnUse",
    x1: 406.1311,
    y1: 259.265,
    x2: 390.4472,
    y2: 243.5067
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#363A0D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.141,
    style: {
      stopColor: "#393D10"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3347,
    style: {
      stopColor: "#414618"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.559,
    style: {
      stopColor: "#515528"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8043,
    style: {
      stopColor: "#696E45"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#818866"
    }
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "404.2,270.6 414.3,256.9 401.7,241.5 392.1,254.9  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_8_",
    gradientUnits: "userSpaceOnUse",
    x1: 435.4239,
    y1: 211.5232,
    x2: 402.7099,
    y2: 256.5856
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3358,
    style: {
      stopColor: "#F9852B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F2BA81"
    }
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "444.5,215.7 420.2,215.7 401.7,241.5 414.3,256.9  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_9_",
    gradientUnits: "userSpaceOnUse",
    x1: 384.5755,
    y1: 281.7241,
    x2: 418.016,
    y2: 233.7291
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A0D33C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5287,
    style: {
      stopColor: "#BEDE8A"
    }
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M371,284.1h21.2c1.3,0,2.5-0.6,3.3-1.7l8.7-11.8l-12.1-15.7L371,284.1z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_10_",
    gradientUnits: "userSpaceOnUse",
    x1: 384.6151,
    y1: 232.2163,
    x2: 404.031,
    y2: 257.957
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EFD13B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1405,
    style: {
      stopColor: "#EFD23F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2657,
    style: {
      stopColor: "#EED649"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.385,
    style: {
      stopColor: "#EEDC5A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5007,
    style: {
      stopColor: "#EEE474"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6128,
    style: {
      stopColor: "#EDEE96"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6514,
    style: {
      stopColor: "#EDF3A4"
    }
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "391.3,228.7 371.9,228.7 392.1,254.9 401.7,241.5  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_11_",
    gradientUnits: "userSpaceOnUse",
    x1: 427.3803,
    y1: 286.422,
    x2: 391.7978,
    y2: 241.2702
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#8D71B4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9117,
    style: {
      stopColor: "#C3ACCE"
    }
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M404.2,270.6l9.3,12c0.8,1,2,1.6,3.3,1.6l19.9-0.1l-22.3-27.3L404.2,270.6z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_12_",
    gradientUnits: "userSpaceOnUse",
    x1: 356.4616,
    y1: 282.219,
    x2: 357.317,
    y2: 227.0677
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#373A0F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9117,
    style: {
      stopColor: "#71AF37"
    }
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M364.9,215.9v68.2H349v-68.2H364.9z"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Calque_3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTraffixcolored);
export default __webpack_public_path__ + "static/media/Traffixcolored.89fb2eb0c866324b11c0ddd9654fe1d3.svg";
export { ForwardRef as ReactComponent };